import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { QuestionsById, SurveyType } from "./types";

const commonQuestions = (
  strictLocalize: StrictLocalizeFunction
): Omit<QuestionsById<SurveyType>, "4" | "5"> => ({
  "1": {
    label: strictLocalize({
      defaultMessage: "Took too long to resolve my issue",
      description: {
        text: "One of reasons for bad CSAT",
        img: "https://cdn.faire.com/fastly/c322d4cd11585c492833dd61b13d958814da01f11b79b5038c89b1a928e1b2a4.png",
      },
    }),
    checked: false,
  },
  "2": {
    label: strictLocalize({
      defaultMessage: "Agent wasn’t helpful",
      description: {
        text: "One of reasons for bad CSAT",
        img: "https://cdn.faire.com/fastly/c322d4cd11585c492833dd61b13d958814da01f11b79b5038c89b1a928e1b2a4.png",
      },
    }),
    checked: false,
  },
  "3": {
    label: strictLocalize({
      defaultMessage: "Issue wasn’t resolved",
      description: {
        text: "One of reasons for bad CSAT",
        img: "https://cdn.faire.com/fastly/c322d4cd11585c492833dd61b13d958814da01f11b79b5038c89b1a928e1b2a4.png",
      },
    }),
    checked: false,
  },
});

const buildOtherQuestion = (strictLocalize: StrictLocalizeFunction) => {
  return {
    label: strictLocalize({
      defaultMessage: "Other",
      description: {
        text: "Other reason for bad CSAT",
        img: "https://cdn.faire.com/fastly/dc0331e2b47b36b77aada6597b0620bb0954fcde9185d43d0ee82ecc6b6b526c.png",
      },
    }),
    checked: false,
  };
};

export const initQuestions = (
  strictLocalize: StrictLocalizeFunction,
  type: SurveyType
): QuestionsById<typeof type> => {
  if (type === "chat") {
    return {
      ...commonQuestions(strictLocalize),
      "4": {
        label: strictLocalize({
          defaultMessage: "Issue needed support via email",
          description: {
            text: "One of reasons for bad CSAT",
            img: "https://cdn.faire.com/fastly/c322d4cd11585c492833dd61b13d958814da01f11b79b5038c89b1a928e1b2a4.png",
          },
        }),
        checked: false,
      },
      "5": buildOtherQuestion(strictLocalize),
    } as QuestionsById<"chat">;
  } else {
    return {
      ...commonQuestions(strictLocalize),
      "4": buildOtherQuestion(strictLocalize),
    } as QuestionsById<"email">;
  }
};
